<template>
  <div class="big patient-msg">
    <div class="page_title">随访列表</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container" style="padding: 10px 20px 20px 20px">
        <div class="search-box">
          <!-- 医生姓名 -->
          <div class="item">
            <span>医生姓名</span>
            <div class="item-content">
              <el-input
                v-model="PatientMsgForm.doctor_name"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>

          <!-- 医生手机号 -->
          <div class="item">
            <span>医生手机</span>
            <div class="item-content">
              <el-input
                v-model="PatientMsgForm.doctor_phone"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>

          <!-- 患者姓名 -->
          <div class="item">
            <span style="width: 70px">患者姓名</span>
            <div class="item-content">
              <el-input
                v-model="PatientMsgForm.user_name"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
                placeholder="患者"
              ></el-input>
            </div>
          </div>

          <!-- 患者手机 -->
          <div class="item">
            <span>患者手机</span>
            <div class="item-content">
              <el-input
                v-model="PatientMsgForm.user_phone"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>

          <!-- 收获时间 -->
          <div class="item">
            <span style="width: 70px">收获时间</span>
            <div class="item-content">
              <el-date-picker
                v-model="PatientMsgForm.create_time"
                size="small"
                type="daterange"
                align="right"
                unlink-panels
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                :picker-options="pickerOptions"
                @change="getList"
              >
              </el-date-picker>
            </div>
          </div>

          <!-- 开方时间 -->
          <div class="item">
            <span style="width: 70px">开方时间</span>
            <div class="item-content">
              <el-date-picker
                v-model="PatientMsgForm.completion_time"
                size="small"
                type="daterange"
                align="right"
                unlink-panels
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                :picker-options="pickerOptions"
                @change="getList"
              >
              </el-date-picker>
            </div>
          </div>

          <!-- 药品剂型 -->
          <div class="item">
            <span>药品剂型</span>
            <div class="item-content">
              <el-select
                v-model="PatientMsgForm.drug_type"
                placeholder="请选择"
                size="small"
                @change="getList"
                clearable
              >
                <el-option
                  v-for="item in drug_type_list"
                  :key="item.drug_type"
                  :label="item.drug_type_name"
                  :value="item.drug_type"
                ></el-option>
              </el-select>
            </div>
          </div>

          <!-- 随访单填写 -->
          <div class="item">
            <span>随访单填写</span>
            <div class="item-content">
              <el-radio-group
                v-model="PatientMsgForm.is_inquiry"
                size="small"
                @change="getList"
              >
                <el-radio :label="''">全部</el-radio>
                <el-radio :label="1">已填</el-radio>
                <el-radio :label="2">未填</el-radio>
              </el-radio-group>
            </div>
            <el-button
              type="primary"
              size="small"
              style="margin-left: 20px"
              @click="getList"
              >查询</el-button
            >
            <el-button size="small" @click="restBtn">重置</el-button>
          </div>
        </div>

        <div style="border: solid 1px #c9cbd6">
          <el-table
            v-loading="tableLoading"
            :data="patientMsgData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'sex'">
                  <span v-if="scope.row.sex == 1">男</span>
                  <span v-if="scope.row.sex == 2">女</span>
                  <span v-if="!scope.row.sex">未知</span>
                </div>

                <div v-else-if="item.prop == 'create_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'completion_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'write_count'">
                  {{
                    scope.row[item.prop]
                      ? `已填${scope.row[item.prop]}次`
                      : "未填"
                  }}
                </div>

                <div v-else>
                  {{
                    JSON.stringify(scope.row[item.prop]) === "null"
                      ? ""
                      : scope.row[item.prop]
                  }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              width="120"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1981')
                      : false
                  "
                  @click="toDetail(scope.row)"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination
          v-show="totalNum > 0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import message from "@/api/message.js";
import Pagination from "@/components/Pagination/index";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      PatientMsgForm: {
        doctor_name: "",
        doctor_phone: "",
        user_name: "",
        user_phone: "",
        create_time: [],
        completion_time: [],
        drug_type: "",
        is_inquiry: "",
      },
      drug_type_list: [],
      tableHeader: [
        {
          label: "患者姓名",
          prop: "user_name",
          width: "auto",
          align: "center",
          fixed: "left",
        },
        {
          label: "性别",
          prop: "sex",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "年龄",
          prop: "age",
          width: "120",
          align: "center",
          fixed: false,
        },
        {
          label: "手机号",
          prop: "phone",
          width: "120",
          align: "center",
          fixed: false,
        },
        {
          label: "医生姓名",
          prop: "doctor_name",
          width: "110",
          align: "center",
          fixed: false,
        },
        {
          label: "医生手机号",
          prop: "doctor_phone",
          width: "140",
          align: "center",
          fixed: false,
        },
        {
          label: "处方号",
          prop: "pre_id",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "处方类型",
          prop: "drug_type_name",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "开方时间",
          prop: "create_time",
          width: "140",
          align: "center",
          fixed: false,
        },
        {
          label: "收货时间",
          prop: "completion_time",
          width: "140",
          align: "center",
          fixed: false,
        },
        {
          label: "需要推送次数",
          prop: "need_send_times",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "已推送次数",
          prop: "send_times",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "随访单填写",
          prop: "write_count",
          width: "auto",
          align: "center",
          fixed: false,
        },
      ],
      patientMsgData: [],
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getDrugTypeList();
    this.getList();
  },
  methods: {
    //获取平台开方可以选择的剂型列表
    getDrugTypeList() {
      let platform_type = 3;
      this.axios
        .post("platform/photograph/getDrugTypeList", { platform_type })
        .then((res) => {
          this.drug_type_list = res.data.list;
        });
    },

    getList() {
      let params = Object.assign({}, this.pagination, this.PatientMsgForm);
      params = _.omit(params, ["create_time"]);
      let create_time = this.PatientMsgForm.create_time;
      params["create_start_time"] = create_time ? create_time[0] : "";
      params["create_end_time"] = create_time ? create_time[1] : "";

      let completion_time = this.PatientMsgForm.completion_time;
      params["completion_time_start"] = completion_time
        ? completion_time[0]
        : "";
      params["completion_time_end"] = completion_time ? completion_time[1] : "";

      this.tableLoading = true;
      message.inquiryuserbusinesslist(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.patientMsgData = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    toDetail(row) {
      this.$router.push({
        path: "/home/message/InquiryList",
        query: {
          doctor_id: row.doctor_id,
          business_id: row.business_id,
          patient_id: row.patient_id,
        },
      });
    },
    restBtn() {
      for (let key in this.PatientMsgForm) {
        if (key == "create_time" || key == "completion_time") {
          this.PatientMsgForm[key] = [];
        } else {
          this.PatientMsgForm[key] = "";
        }
      }
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.patient-msg {
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        width: 80px;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
</style>
